import Auth, { FetchAPI, ParamsSerializer } from './auth-service';

class SuricataDataService {
    constructor () {
        if (!SuricataDataService.instance) {
            SuricataDataService.instance = this;
        }
        this.searchPlaceholder = 'Search Suricata rules';

        this.importFromURL = (data) => {
            return FetchAPI({
                url: 'rules/file/suricata/-import/',
                method: 'POST',
                body: data,
            });
        };

        this.importSuricataRules = (data) => {
            return FetchAPI({
                url: 'rules/file/suricata/-upload/',
                method: 'POST',
                body: data,
            });
        };

        this.listSuricataSyncURLs = () => {
            return FetchAPI({
                url: 'rules/file/suricata/url-file/',
                method: 'GET',
            });
        };

        this.importFromFile = (content) => {
            const a = Auth.getAuth();
            const form = new FormData();
            form.append('fileblob', content);

            return fetch('/api/rules/file/suricata/url-file/', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${a.token}`,
                },
                body: form,
            }).then((res) => {
                return res;
            }).catch(response => {
                if ([401, 403].indexOf(response.status) !== -1) {
                    return Auth.boot();
                }
            });
        };

        this.previewGarbageCollection = () => {
            return FetchAPI({
                url: 'rules/gc/',
                method: 'GET',
            });
        };

        this.runGarbageCollection = () => {
            return FetchAPI({
                url: 'rules/gc/',
                method: 'DELETE',
            });
        };

        this.fastPreviewGarbageCollection = () => {
            return FetchAPI({
                url: 'rules/gc/count/',
                method: 'GET',
            });
        };

        this.deleteGroup = (name) => {
            return FetchAPI({
                url: `rules/group/suricata/${name}/`,
                method: 'DELETE',
            });
        };

        this.getPoliciesWithGroupEnabled = (name) => {
            return FetchAPI({
                url: `rules/group/suricata/${name}/policies/`,
                method: 'GET',
            });
        };

        this.refreshPolicyCache = () => {
            return FetchAPI({
                url: 'rules/policy/refresh/',
                method: 'PUT',
            });
        };

        // Discard shadow policy
        this.deleteShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'DELETE',
                url: `rules/policy/suricata/shadow/${policy}`,
            });
        };

        // Does a shadow policy exist?
        this.checkShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'GET',
                url: `rules/policy/suricata/shadow/${policy}/-query`,
            });
        };

        // Create a shadow policy
        this.createShadowPolicy = (policy) => {
            return FetchAPI({
                method: 'POST',
                url: `rules/policy/suricata/shadow/${policy}`,
            });
        };

        // Get a shadow policy after check
        this.getShadowPolicy = (policy, uuid) => {
            return FetchAPI({
                method: 'GET',
                url: `rules/policy/suricata/shadow/${policy}/${uuid}`,
            });
        };

        // Update a shadow policy
        this.updateShadowPolicy = (policy, uuid, body) => {
            return FetchAPI({
                method: 'POST',
                url: `rules/policy/suricata/shadow/${policy}/${uuid}`,
                body: body,
            });
        };

        // Save the shadow policy as a policy and discard shadow
        this.saveShadowPolicy = (policy, uuid) => {
            return FetchAPI({
                method: 'PUT',
                url: `rules/policy/suricata/shadow/${policy}/${uuid}`,
            });
        };

        // Get shadow policy groups
        this.getShadowPolicyGroups = (policy, uuid, query) => {
            const body = {
                group_search: query.search,
            };
            if (Object.prototype.hasOwnProperty.call(query, 'enabled')) {
                body.enabled = query.enabled;
            }
            return FetchAPI({
                method: 'PUT',
                url: `rules/policy/suricata/shadow/${policy}/${uuid}/groups?${ParamsSerializer(query)}`,
                body: body,
            });
        };

        // Get shadow policy rules
        this.getShadowPolicyRules = (policy, uuid, query) => {
            const body = {
                // rule_search: query.search,
                search: query.search,
            };
            if (Object.prototype.hasOwnProperty.call(query, 'enabled')) {
                body.enabled = query.enabled;
            }
            if (Object.prototype.hasOwnProperty.call(query, 'gc_candidate')) {
                body.gc_candidate = query.gc_candidate;
            }
            if (Object.prototype.hasOwnProperty.call(query, 'keep')) {
                body.keep = query.keep;
            }
            return FetchAPI({
                method: 'PUT',
                url: `rules/policy/suricata/shadow/${policy}/${uuid}/rules?${ParamsSerializer(query)}`,
                body: body,
            });
        };

        this.updatePolicy = (policy, type, data) => {
            return FetchAPI({
                url: `rules/policy/suricata/${policy}/suricata_rules`,
                method: 'PUT',
                body: data,
            });
        };

        this.listPolicyGroups = (policy, typ, query, body) => {
            return FetchAPI({
                method: 'PUT',
                url: `rules/policy/suricata/${policy}/groups/-list?${ParamsSerializer(query)}`,
                body: body,
            });
        };

        this.listPolicyRules = (policy, typ, query, body) => {
            return FetchAPI({
                method: 'PUT',
                url: `rules/policy/suricata/${policy}/rules/-list?${ParamsSerializer(query)}`,
                body: body,
            });
        };

        this.getPolicyRule = (id) => {
            return FetchAPI({
                method: 'GET',
                url: `rules/rule/suricata/${id}/`,
            });
        };

        this.createCustomRule = (body) => {
            return FetchAPI({
                url: 'rules/rule/suricata/',
                method: 'POST',
                body: body,
            });
        };

        this.getRuleDetails = (id, ver) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/?${ParamsSerializer({ ver })}`,
                method: 'GET',
            });
        };

        // Get rule details for a policy, which includes action and enabled
        this.getPolicyRuleDetails = (policy, id) => {
            return FetchAPI({
                url: `rules/policy/suricata/${policy}/suricata_rules/rule/${id}/`,
                method: 'GET',
            });
        };

        this.updateCustomRule = (id, data) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/`,
                method: 'PUT',
                body: data,
            });
        };

        this.deleteRule = (id) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/`,
                method: 'DELETE',
            });
        };

        this.getRuleVersionHistory = (id) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/history/`,
                method: 'GET',
            });
        };

        this.getPoliciesWithRuleChanges = (id) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/policies/`,
                method: 'GET',
            });
        };

        this.getRuleFromAllPolicies = (id) => {
            return FetchAPI({
                url: `rules/rule/suricata/${id}/rules/`,
                method: 'GET',
            });
        };

        this.getVars = (name) => {
            return FetchAPI({
                url: `sensors/groups/suricata_config/${name}`,
                method: 'GET',
            });
        };

        this.updateVars = (name, data) => {
            return FetchAPI({
                url: `sensors/groups/suricata_config/${name}`,
                method: 'PUT',
                body: data,
            });
        };

        this.isManaged = () => {
            return FetchAPI({
                url: 'rules/-managed/',
                method: 'GET',
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_suricata') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_suricata', JSON.stringify(searches));
        };

        return SuricataDataService.instance;
    }
}

const SuricataService = new SuricataDataService();

export default SuricataService;
